"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const actions_1 = require("./actions");
const initialState = {
    requested: [],
    items: []
};
function trackRequestedEvents(state, action) {
    return {
        ...state,
        requested: state.requested.concat(action.ids)
    };
}
function putEvents(state, action) {
    return {
        ...state,
        items: state.items.concat(action.events)
    };
}
function reducer(state = initialState, action) {
    switch (action.type) {
        case actions_1.actions.TRACK_REQUESTED_EVENTS: return trackRequestedEvents(state, action);
        case actions_1.actions.PUT_EVENTS: return putEvents(state, action);
        default: return state;
    }
}
exports.reducer = reducer;



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-website-store/events/reducer.ts